module.exports = __webpack_public_path__ + "img/cricket-thumb.cb4ec2fc.jpg";